// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsBusinessSourcesResult = objectOf({
  business_sources: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      storage_size: number,
      fields: arrayOf(
        objectOf({
          name: string,
          token: number,
          type: string,
        })
      ),
    })
  ),
});
